module.exports = __webpack_public_path__ + "static/media/imss.8983dd72.jpg";